import { LinearGradient } from 'expo-linear-gradient';
import { router } from 'expo-router';
import { useSetAtom } from 'jotai/index';
import * as React from 'react';
import {
    BackButton,
    BackButtonIconType,
    BodySmallRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Emphasized,
    isWeb,
    SafeAreaView,
    ScrollView,
    Separator,
    tokens,
    YStack,
} from 'smoothie';

import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import { getUserGuideName } from '../../common/utils/userUtils';
import LogRocketFacade from '../../logger/log-rocket/LogRocketFacade';
import { billReviewSourceAtom } from '../state/BillsAtoms';
import { BillsCategories } from './BillsCategoryInfo';

const BillsDiscovery = () => {
    LogRocketFacade.tagPage('BillsDiscovery');

    const user = useAuthedUser();
    const guideName = getUserGuideName(user);
    const setBillReviewSource = useSetAtom(billReviewSourceAtom);

    setBillReviewSource('home-review');

    return (
        <SafeAreaView
            style={{
                flex: 1,
            }}
        >
            <YStack
                height="100%"
                paddingHorizontal={24}
                paddingVertical={isWeb ? 24 : undefined}
                justifyContent="space-between"
                maxWidth={700}
                alignSelf="center"
            >
                <BackButton
                    fallbackRoute="/"
                    iconType={BackButtonIconType.ARROW_LEFT}
                />
                <YStack flex={1}>
                    <ScrollView showsVerticalScrollIndicator={isWeb}>
                        <YStack paddingVertical={28}>
                            <H5Emphasized paddingBottom={12}>
                                We&apos;ll keep track of your bills so you
                                don&apos;t have to
                            </H5Emphasized>
                            <BodySmallRegular color="$gray1000">
                                Understanding how much you have committed to
                                recurring expenses helps you and {guideName}{' '}
                                understand your full financial picture.
                            </BodySmallRegular>
                        </YStack>
                        <YStack>
                            <BodySmallRegular
                                paddingBottom={16}
                                color="$gray1000"
                            >
                                Bill categories
                            </BodySmallRegular>
                            <Separator />
                        </YStack>
                        <BillsCategories />
                    </ScrollView>
                    <LinearGradient
                        colors={[
                            'rgba(255, 255, 255, 0)',
                            tokens.color.light.brand.white,
                        ]}
                        style={{
                            height: 20,
                            width: '100%',
                            position: 'absolute',
                            bottom: 0,
                        }}
                        pointerEvents="none"
                    />
                </YStack>
                <Separator />
                <YStack paddingTop={16} paddingBottom={isWeb ? 16 : undefined}>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Next"
                        onPress={() => {
                            router.navigate('/bills/bills-discovery-accounts');
                        }}
                    />
                </YStack>
            </YStack>
        </SafeAreaView>
    );
};

export default BillsDiscovery;
